/* ── formatters ─────────────────────────────────────────────────── */
export const fmt = (v) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(v);
export const fmtCompact = (v) => {
    if (v == null || isNaN(v)) return 'Rp 0';
    const abs = Math.abs(v);
    if (abs >= 1_000_000_000) return `Rp ${(v / 1_000_000_000).toFixed(2).replace('.00', '')} M`;
    // if (abs >= 1_000_000) return `Rp ${(v / 1_000_000).toFixed(1).replace('.0', '')} jt`;
    // if (abs >= 1_000) return `Rp ${(v / 1_000).toFixed(0)} rb`;
    return fmt(v);
};
export const fmtNum = (v) => new Intl.NumberFormat('id-ID').format(v);